// extracted by mini-css-extract-plugin
export default {"textWrapper":"message-area_textWrapper__JOlHS","msgTitle":"message-area_msgTitle__7X0gV","msgWrapper":"message-area_msgWrapper__9L+P9","target":"message-area_target__sfSJ1"};